import type { DashboardNavigationTrace } from "./dashboardNavigationTrace";

export type DashboardLink = DashboardNavigationTrace & {
  to: string;
};

export const DASHBOARD_STUDY_TERMINAL_STATUSES = [
  "completed",
  "cancelled",
  "archived",
  "no_show",
] as const;

export function buildStudiesLink(input: {
  label: string;
  expectedCount: number | string;
  countSource: string;
  metricKey: string;
  processing?: string;
  studyScope?: "active";
  studyStatus?: string;
  assigned?: "me";
  priority?: string;
  aiTriage?: string;
  monitoring?: string;
  range?: string;
}): DashboardLink {
  const params = new URLSearchParams();
  if (input.processing && input.processing !== "all") {
    params.set("processing", input.processing);
  }
  if (input.studyScope) {
    params.set("studyScope", input.studyScope);
    if (!input.processing) {
      params.set("processing", "all");
    }
  }
  if (input.studyStatus) {
    params.set("studyStatus", input.studyStatus);
  }
  if (input.assigned) {
    params.set("assigned", input.assigned);
  }
  if (input.priority) {
    params.set("priority", input.priority);
  }
  if (input.aiTriage) {
    params.set("aiTriage", input.aiTriage);
  }
  if (input.monitoring) {
    params.set("monitoring", input.monitoring);
  }
  if (input.range) {
    params.set("range", input.range);
  }

  const query = params.toString();
  const to = query ? `/studies?${query}` : "/studies";

  return {
    label: input.label,
    expectedCount: input.expectedCount,
    countSource: input.countSource,
    metricKey: input.metricKey,
    targetUrl: to,
    to,
  };
}

export function buildReportsReviewLink(input: {
  label: string;
  expectedCount: number | string;
  countSource: string;
  metricKey: string;
  status?: string;
  sort?: "oldest" | "newest";
}): DashboardLink {
  const params = new URLSearchParams();
  if (input.status && input.status !== "all") {
    params.set("status", input.status);
  }
  if (input.sort) {
    params.set("sort", input.sort);
  }

  const query = params.toString();
  const to = query ? `/reports/review?${query}` : "/reports/review";

  return {
    label: input.label,
    expectedCount: input.expectedCount,
    countSource: input.countSource,
    metricKey: input.metricKey,
    targetUrl: to,
    to,
  };
}

export function buildWorklistLink(input: {
  label: string;
  expectedCount: number | string;
  countSource: string;
  metricKey: string;
  triage?: string;
  monitoring?: string;
  sla?: string;
  ai?: string;
  assigned?: string;
}): DashboardLink {
  const params = new URLSearchParams();
  if (input.triage) params.set("triage", input.triage);
  if (input.monitoring) params.set("monitoring", input.monitoring);
  if (input.sla) params.set("sla", input.sla);
  if (input.ai) params.set("ai", input.ai);
  if (input.assigned) params.set("assigned", input.assigned);

  const query = params.toString();
  const to = query ? `/worklist?${query}` : "/worklist";

  return {
    label: input.label,
    expectedCount: input.expectedCount,
    countSource: input.countSource,
    metricKey: input.metricKey,
    targetUrl: to,
    to,
  };
}
